<template>
    <svg width="29" height="24" viewBox="0 0 29 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 14L14.5 10L10 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    </svg>
</template>
